import { useEffect } from "react";
import useGA from "./useGA";
import { GaEvent } from "./static";

const useGAViewScreen = (viewName: string, viewSection: string) => {
  const { triggerGAEvent } = useGA();

  useEffect(() => {
    triggerGAEvent(GaEvent.VIEW_SCREEN, {
      viewName,
      viewSection,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewName, viewSection]);
};

export default useGAViewScreen;
